<template>
	<div class="mb-10 w-full space-y-1">
		<h2 class="mb-0 text-left lg:m-auto lg:text-center">
			Frequently asked questions
		</h2>
		<p class="text-left text-3xl lg:m-auto lg:text-center">
			on car subscription
		</p>
	</div>

	<div class="xl:px-44">
		<AccordionFaq>
			<AccordionFaqGroup :double-borders="true">
				<AccordionFaqItem :is-checked="true">
					<template #title>
						Is car subscription service cheaper than buying?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<p>
								Depending on your circumstance, buying a car
								outright may be the cheaper option if you are
								looking at long-term ownership. However, this
								requires a lump sum payment and when owning the
								car, you carry all the costs and risks of any
								maintenance or mechanical issues. These can add
								up and can become very expensive, especially on
								used cars.
							</p>
						</div>
					</template>
				</AccordionFaqItem>

				<AccordionFaqItem>
					<template #title>
						Is it worth subscribing to a car?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<p>
								The weekly subscription aims to cover all the
								key costs of owning, maintaining and running a
								car such as depreciation, interest,
								registration, insurance, routine maintenance,
								roadside assist, mechanic faults, faulty and
								worn tyres and batteries. The subscription cost
								excludes tolls, fuel and infringements.
							</p>
							<p>
								Car subscription services are more flexible than
								a lease or car financing and can be a more
								affordable way to access a car if you cannot
								afford to buy it outright today.
							</p>
							<p>
								Car subscription services also remove the risks
								of buying a lemon. The risks of maintenance and
								mechanical faults are spread across a fleet of
								cars vs an individual.
							</p>
						</div>
					</template>
				</AccordionFaqItem>

				<AccordionFaqItem>
					<template #title>
						Is a car subscription the same as a lease?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<p>
								A car subscription is a flexible alternative to
								a traditional lease.
							</p>
							<p>
								Most people finance or lease a car for a period
								of time, often between 3 - 7 years. With
								subscription, there is no term or contract, you
								can stop or swap your car with just 2 weeks
								notice.
							</p>
							<p>
								Financing or leasing a car may also just cover
								the cost of the car. With subscription,
								customers pay a fixed recurring payment for all
								key costs, excluding fuel, tolls and fines.
							</p>
							<p>
								With subscription there are no hidden or exit
								fees. The total minimum costs includes the
								upfront fee and the initial first four week
								payment.
							</p>
						</div>
					</template>
				</AccordionFaqItem>

				<AccordionFaqItem>
					<template #title>
						Can you buy your subscription car if you like it?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<p>
								At any time, you can buy, or finance your
								subscription car.
							</p>
							<p>
								Since we started offering a subscription
								service, we have observed a trend of customers
								subscribing to cars, loving them and often
								asking to purchase the car.
							</p>
							<p>
								Subscribers can simply request a price to
								purchase their subscription car and we’ll help
								compare the costs of financing without any
								impact on their credit rating. This way, you can
								easily weigh up the costs of a subscription
								versus buying a car using finance.
							</p>
							<p>
								We’re always adding new cars to our fleet.
								Browse the latest selection of cars here.
							</p>
						</div>
					</template>
				</AccordionFaqItem>

				<AccordionFaqItem>
					<template #title>
						Can I buy or finance cars from carbar?
					</template>
					<template #content>
						<div class="mt-4 space-y-4 text-lg text-gray-575">
							<p>You definitely can.</p>
							<p>
								Besides our highly recommended car subscription
								services, there is also the option to finance or
								buy a used car.
							</p>
							<p>
								We have a wide range of quality used cars
								available to buy or apply for finance entirely
								online.
							</p>
						</div>
					</template>
				</AccordionFaqItem>
			</AccordionFaqGroup>
		</AccordionFaq>
	</div>
</template>

<script setup>
import AccordionFaq from '@/components/faqs/AccordionFaq.vue'
import AccordionFaqGroup from '@/components/faqs/AccordionFaqGroup.vue'
import AccordionFaqItem from '@/components/faqs/AccordionFaqItem.vue'
</script>
